// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1BulkForecastsImportResponseSchema = z.object({
  deleted_ids: z.array(z.number().int()).describe("IDs of successfully deleted tasks"),
  created_ids: z.array(z.number().int()).describe("IDs of successfully created tasks"),
  updated_ids: z.array(z.number().int()).describe("IDs of successfully updated tasks"),
});
